// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__8MHY1","file":"styles_file__1L_Tj"};